import { SortOrder, TransactionSortField } from 'views/types/typeTransaction';
import { NetworkTypes } from 'views/types/wallets';
import { create, useStore } from 'zustand';

interface SortState {
  sortBy: TransactionSortField | null;
  sortOrder: SortOrder | null;
}

interface IUserWalletsTableStore {
  page: number;
  networkType: null | NetworkTypes;
  searchBy: string;
  itemsPerPage: number;
  sortState: SortState;

  setPage: (page: number) => void;
  setTxType: (networkType: NetworkTypes) => void;
  setSearchBy: (value: string) => void;
  setItemsPerPage: (count: number) => void;
  setSortState: (state: SortState) => void;
  resetFilters: () => void;
}

const defaultState = {
  page: 0,
  networkType: null as IUserWalletsTableStore['networkType'],
  searchBy: '',
  itemsPerPage: 10,
  sortState: {
    sortBy: null,
    sortOrder: null,
  } as SortState,
};

export const userWalletsTableStore = create<IUserWalletsTableStore>(set => ({
  ...defaultState,

  setPage: page => set({ page }),
  setTxType: networkType => set({ networkType }),
  setSearchBy: searchBy => set({ searchBy }),
  setItemsPerPage: itemsPerPage => set({ itemsPerPage }),
  setSortState: sortState => set({ sortState }),
  resetFilters: () => set({ ...defaultState }),
}));

export const useWalletsFilterStore = () => useStore(userWalletsTableStore);
